window.SPACE = 32;

// Little light following mouse.
window.flyMode = false;
window.arr = []

const posss = () => {
    const pos = SJ.camera.screenToWorld(createVector(
        SJ.mouseScreenX,
        SJ.mouseScreenY
    ));

    pos.x += -28;
    pos.y += -26;

    pos.x -= SJ.V.textureOffset.x;
    pos.y -= SJ.V.textureOffset.y;

    pos.x /= SJ.V.padScale
    pos.y /= SJ.V.padScale

    pos.x = Math.round(pos.x)
    pos.y = Math.round(pos.y)

    return pos;
}

const onKeyPressed = () => {
    // Gonna delete later
    if (window.location.origin !== "https://skijumpsimulator.com")
        SJ.movingObjects.objectMoveManagement(keyCode);

  if(SJ._state != SJ._STATE.GAME || !SJ.mouseMoveEnable) { return; }

    SJ.jumper.onKeyPressed();
    SJ.pad.onKeyPressed();
    SJ.itemsManager.onKeyPressed();

    // Gonna delete later
    // if (window.location.origin !== "https://skijumpsimulator.com")
        SJ.camera.moveWithArrows(keyCode);

    // SJ.weather.manage(keyCode);

    if (keyCode === ENTER || keyCode === SPACE) {
        if (SJ.jumpParamDisplay.isVisible) {

            SJ.jumpParamDisplay.hide();

            if (SJ.tournament) {
                if (SJ.tournament.lastMap && SJ.tournament.endOfSeries) {
                    fetch(`${SJ.APILink}user/setFinishedTournaments.php`, {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify(
                          {
                            "name": SJ.playerData.data['name']
                          }
                        )
                      })
                      .then(res => res.json())
                      .then(data => {
                        if (data.type === 'error') console.log(data.message);
                        else {
                            SJ.playerData.data['finishedTournaments'] += 1;
                            SJ.tournament.endTournament();
                        }
                      })
                      .catch((e) => console.log(e));
                } else {
                    SJ.tournament.continueTournament();
                }
            } else {
                SJ.restartGame();
            }
        }
    }

    if (keyCode == CONTROL) {
        const pos = posss();
        arr.push(pos);
        print(pos);
    } else if (keyCode == SHIFT) {
        let str = ""
        arr.forEach(pos => {
            str += `{"x":${pos.x},"y":${pos.y}},\n`;
        })
        print(str);
    } else if (keyCode === 90) {
        // SJ.playerData.changePlayer();
    }
}

const onKeyReleased = () => {
    if (SJ._state != SJ._STATE.GAME  || !SJ.mouseMoveEnable) { return; }

    SJ.jumper.onKeyReleased();
}

const onTouchStarted = () => {

  SJ.ControlJoystick.onTouchStarted();

  if(SJ._state == SJ._STATE.LOADING  || !SJ.mouseMoveEnable) { return; }

  updateMouseScreenPosition();
  SJ.ControlJoystick.setStartPosition();


  if(SJ.ScreensManager.onMousePress()) { return; }
  if(SJ._state != SJ._STATE.GAME) { return; }

  if(isMouseInCanvas()) {
    SJ.pad.onScreenTouched();
    SJ.jumper.onScreenTouched();
  }

  SJ.mobileSwipeSteeringInfo.show();
}

const onTouchEnded = () => {

    SJ.ControlJoystick.onTouchEnded();

    if (SJ._state == SJ._STATE.LOADING) { return; }
    if (SJ.ScreensManager.onMouseRelease()) { return; }
    if (SJ._state != SJ._STATE.GAME) { return; }

    if (isMouseInCanvas()) {
        SJ.jumper.onScreenTouchEnded();
    }

    SJ.mobileSwipeSteeringInfo.hide();

}

const onMouseMoved = () => {
    if (SJ._state == SJ._STATE.LOADING) { return; }

    if (SJ.mouseMoveEnable)
        updateMouseScreenPosition();

    SJ.ScreensManager.onMouseMove();

    // const pos = posss();
    // SJ.fly.x = pos.x;
    // SJ.fly.y = pos.y;
}

const onMouseDragged = () => {
    if (SJ._state == SJ._STATE.LOADING) { return; }

  updateMouseScreenPosition();
	SJ.ControlJoystick.updatePosition();

  if(SJ._state != SJ._STATE.GAME) { return; }

    if (SJ._state != SJ._STATE.GAME) { return; }

    if (isMouseInCanvas()) {
        // SJ.jumper.onScreenTouchMoved();
    }
}

const onMouseWheelMove = (event) => {

    if (SJ._state == SJ._STATE.LOADING) { return; }

    SJ.ScreensManager.onMouseWheelMove(event.delta);
}

const isMouseInCanvas = () => {
    return mouseX >= 0 && mouseX < width && mouseY >= 0 && mouseY < height;
}

const updateMouseScreenPosition = () => {
    SJ.mouseScreenX = floor(mouseX / SJ.canvasScaler.scale);
    SJ.mouseScreenY = floor(mouseY / SJ.canvasScaler.scale);
}

window.setupInputManager=function () {
    window.keyPressed = onKeyPressed;
    window.keyReleased = onKeyReleased;
    window.mouseMoved = onMouseMoved;
    window.mouseDragged = onMouseDragged;

    window.mouseWheel = onMouseWheelMove;

    if (SJ.IS_MOBILE) {
        window.touchStarted = onTouchStarted;
        window.touchEnded = onTouchEnded;

        // Remove default behaviour
        // Needed to prevent double event calling on mobile
        window.mousePressed = () => {
        };
        window.mouseReleased = () => {
        };
    } else {
        window.mousePressed = onTouchStarted;
        window.mouseReleased = onTouchEnded;
    }
}
